import request from '@/utils/request'

// 查询列表
export function apiMdmOrgSupplierList (query) {
  return request({
    url: '/mdm/mdmOrgSupplier/list',
    method: 'get',
    params: query
  })
}
// 查询列表
export function apiMdmOrgSupplier (data) {
  return request({
    url: '/mdm/mdmOrgSupplier',
    method: 'put',
    data: data
  })
}
// 查询子库下拉列表
export function apiMdmSelectSupplierWarehouse (data) {
  return request({
    url: '/mdm/mdmOrgSupplier/selectSupplierWarehouse',
    method: 'get',
    params: data
  })
}
